import fade from "./common/fade";
const removePreviousErrorMessage = (errorMessageParent) => {
    var _a;
    if (errorMessageParent.querySelector("span")) {
        (_a = errorMessageParent.querySelector("span")) === null || _a === void 0 ? void 0 : _a.remove();
    }
};
const showReservationFormValidationErrorMessage = (errorMessageParent) => {
    const span = document.createElement("span");
    span.innerHTML = " この項目は必須です。";
    span.style.opacity = "0";
    span.style.color = "red";
    span.className = "validation-error-message";
    errorMessageParent.appendChild(span);
    fade.in(span, "inline");
};
const errorMessageParent = document.querySelector("#reservation-form .subtitle.lesson");
export default {
    isFormValid: (reservationForm) => !!reservationForm.querySelector("[name='lesson']:checked"),
    showErrorMessage: () => {
        showReservationFormValidationErrorMessage(errorMessageParent);
        document.querySelectorAll("span.validation-error-message")[0].scrollIntoView({ behavior: "smooth" });
    },
    removeErrorMessage: () => {
        removePreviousErrorMessage(errorMessageParent);
    },
};
